import React, { useEffect, useState } from "react";
import "./WorkshopsList.css";
import { Flex, Header, SafeArea } from "../../components/layout";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../components/firebase/firebase";
import { Link, useParams } from "react-router-dom";
import { slugify } from "../../function";
import { HiArrowLeft } from "react-icons/hi";
import { logEvent, serializeError } from "../../utils/logger";

function WorkshopsList() {
  const [data, setData] = useState([]);
  const { id } = useParams();

  const fetchArticles = async () => {
    try {
      const dataQuery = query(collection(db, "workshops"), orderBy("title"));
      const querySnapshot = await getDocs(dataQuery);

      // Filtrer les résultats et stocker les ateliers dans un tableau
      const workshops = [];
      querySnapshot.forEach((doc) => {
        console.log(slugify(doc.data().category) === slugify(id));
        console.log(slugify(doc.data().category), slugify(id));
        if (slugify(doc.data().category) === id) {
          workshops.push({ id: doc.id, ...doc.data() });
        }
      });

      setData(workshops); // Mettre à jour l'état avec un tableau d'ateliers
    } catch (error) {
      console.error("Erreur lors du chargement des articles :", error);
      logEvent("ERROR", "DB", "Failed to fetch workshops list", {
        error: serializeError(error),
        collection: "workshops",
        categorySlug: id,
      });
    }
  };

  useEffect(() => {
    fetchArticles();
  }, [id]); // Ajouter `id` comme dépendance pour recharger si la catégorie change

  return (
    <SafeArea className="WorkshopsList">
      <Flex>
        <Link to="/ateliers" className="back">
          <HiArrowLeft />
          Les ateliers
        </Link>
      </Flex>
      <Flex type="col-center" gap={50}>
        <Header title={data.length > 0 ? data[0].category : "Coaching"} />
        <Flex type="center" gap={30} wrap className="content">
          {data.length > 0 ? (
            data.map((d) => (
              <Link key={d.id} to={`/atelier/${d.id}`}>
                {d.title}
              </Link>
            ))
          ) : (
            <p>Ateliers en cours de préparation.</p>
          )}
        </Flex>
      </Flex>
    </SafeArea>
  );
}

export default WorkshopsList;
